import { useServerVarsContext } from '../../global/ServerVarsContext/ServerVarsContext.tsx';
import { TILE_SIZES, type TileSize } from 'dibs-buyer-product-tile/exports/BuyerProductTile.ts';

export const useBuyerProductTileSize = (): Extract<TileSize, 'small' | 'large'> => {
    const { isDesktop } = useServerVarsContext();
    return isDesktop ? TILE_SIZES.large : TILE_SIZES.small;
};
